export function clampLine(lines = 1) {
  return `
    -webkit-line-clamp: ${lines};
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `;
}

